<template>
    <div>
        <span class="PermissionGroupContentSection">
            <input type="checkbox" v-model="isAccountPermissionAccesscheck" @click="CheckAllAccountPermissionRole()" />
            Account Permissions
            <input class="display-none" type="text" v-model="refeshidentiy" v-sanitize-html="refeshidentiy" />
        </span>
        <div v-for="permission in applicationPermissionList" :key="permission.groupName" class="px-3">
            <div class="form-check">
                <label class="PermissionGroup form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="permission.isAccess"
                        :value="permission.groupName" @click="CheckAllPermissionGroupRole(permission)" />
                    {{ permission.groupName }}
                </label>
                
            </div>
            <div class="row justify-content-start">
                <div class="col-4" v-for="role in permission.roles" :key="role.id">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="role.isAccess" :value="role.label"
                                @click="CheckPermissionRole(role, permission)" />
                            {{ role.label }}
                        </label>
                        <img src="../../assets/img/icon_info.png"
                :title="role.helpText"
                :alt="role.helpText"
                class="role-help-icon" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicationPermission",
    data() {
        return {
            applicationPermissionList: this.applicationPermissions,
            PermissionGroupCheck: [],
            RoleCheck: [],
            user: this.userDetail,
            refeshidentiy: 0,
            isPermissionEdited: false,
            permissionCopy: JSON.stringify(this.applicationPermissions),
            isAccountPermissionAccesscheck: this.isAccountPermissionAccess
        };
    },
    props: {
        applicationPermissions: Array,
        isAccountPermissionAccess: Boolean
    },
    watch: {
        isAccountPermissionAccess: function (newValue) {
            this.isAccountPermissionAccesscheck = newValue;
        }
    },
    methods: {
        CheckAllPermissionGroupRole: function (permission) {
            var that = this;
            that.applicationPermissionList.forEach(function (permissionGroup) {
                if (permissionGroup.groupName == permission.groupName) {
                    permissionGroup.isAccess = !permissionGroup.isAccess;
                    that.isPermissionEdited = !that.isPermissionEdited;
                    permissionGroup.roles.forEach(function (role) {
                        role.isAccess = permissionGroup.isAccess;
                    });
                }
                var checkPermission = [];
                checkPermission = that.applicationPermissionList.filter(x => {
                    return (x.isAccess == false || typeof x.isAccess == "undefined");
                });
                if (checkPermission.length == 0) {
                    that.isAccountPermissionAccesscheck = true;
                }
                else
                    that.isAccountPermissionAccesscheck = false
            });
            that.refeshidentiy++;
        },
        CheckAllAccountPermissionRole: function () {
            var that = this;
            that.applicationPermissionList.forEach(function (permissionGroup) {
                permissionGroup.isAccess = !that.isAccountPermissionAccesscheck;
                that.isPermissionEdited = !that.isPermissionEdited;
                permissionGroup.roles.forEach(function (role) {
                    role.isAccess = !that.isAccountPermissionAccesscheck;
                });
            });
            that.refeshidentiy++;
        },
        isPermissionDirty: function () {
            var per = JSON.stringify(this.applicationPermissionList);
            return !(per == this.permissionCopy);
        },
        CheckPermissionRole: function (role, permission) {
            var that = this;
            permission.roles.find(function (item) {
                if (item.label == role.label && item.id == role.id) {
                    item.isAccess = !item.isAccess;
                    that.isPermissionEdited = !that.isPermissionEdited;
                }
            });
            permission.isAccess = true;
            permission.roles.find(function (item) {
                if (item.isAccess == false || typeof item.isAccess == "undefined") {
                    permission.isAccess = item.isAccess;
                }
            });
            var checkrolePermission = [];
            checkrolePermission = that.applicationPermissionList.filter(x => {
                return (x.isAccess == false || typeof x.isAccess == "undefined");
            });
            if (checkrolePermission.length == 0) {
                that.isAccountPermissionAccesscheck = true;
            }
            else
                that.isAccountPermissionAccesscheck = false;
            that.refeshidentiy++;
        },

        GetUserApplicationPermissions: function () {
            var that = this;
            that.RoleCheck = [];
            that.applicationPermissionList.forEach(function (permissionGroup) {
                permissionGroup.roles.forEach(function (role) {
                    if (role.isAccess == true) {
                        that.RoleCheck.push(role.label);
                    }
                });
            });
            return that.RoleCheck;
        }
    }
};
</script>

<style scoped>
    .role-help-icon {
        font-size: 0.8rem;
        color: black;
        margin-left: 0.3em;
        margin-right: 1.5em;
    }
</style>